import Container from "components/Container/Container";
import { GET_SEARCH_FILTERS } from "hooks/useApi";
import useApi from "hooks/useApi/useApi";
import Page from "layout/Page";
import React, { useEffect } from "react";
import SearchScreen from "./Components/SearchScreen";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

const ReportingGenerator = () => {
  const apiParams = GET_SEARCH_FILTERS();
  const [responseState, makeRequest] = useApi();

  useEffect(() => {
    makeRequest(apiParams);
  }, []);

  return (
    <Page title="Reporting Generator">
      {!responseState.data && !responseState.error ? (
        <LoadingSpinner />
      ) : (
        <Container maxWidth="xl" size={100}>
          <SearchScreen data={responseState.data} />
        </Container>
      )}
    </Page>
  );
};

export default ReportingGenerator;
